import React, {useEffect, useState} from "react";
import {WidgetProps} from "../../../../../core/ui/widget/widget";
import {useTranslation} from "react-i18next";
import {Select} from "antd";
import {timezoneService} from "../../../../../../services/timezone/timezone.service";
import {TimezoneLabeled} from "../../../../../../models/timezone/timezone";

export const UIInputWidgetTimezone: React.FC<WidgetProps> = ({value, onChange, loading}) => {

    const {t} = useTranslation('translation', {useSuspense: false});

    const [values, setValues] = useState<TimezoneLabeled[]>([]);

    useEffect(() => {
        timezoneService.getAll().then(values => setValues(values))
    }, [])

    return (
        <Select
            className="selects_block_select"
            showSearch
            dropdownMatchSelectWidth={200}
            optionFilterProp={"children"}
            allowClear
            placeholder={t("ACCOUNT.SETTINGS.SYSTEM.TIMEZONE")}
            value={value}
            onChange={onChange}
            loading={loading}
        >
            {values.map((item) => (
                <Select.Option key={item.name} value={item.name}>{item.label}</Select.Option>
            ))}
        </Select>
    )
}